import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import { mfaRedirectPath } from "@/lib/auth/jwt";

interface MfaEnrollGuardProps {
  children: ReactNode;
}

export function MfaEnrollGuard({ children }: MfaEnrollGuardProps) {
  const accessToken = useAuthStore((state) => state.accessToken);

  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }
  const target = mfaRedirectPath(accessToken);
  if (target && target !== "/auth/mfa/enroll") {
    return <Navigate to={target} replace />;
  }
  return <>{children}</>;
}
